import { Color as FontColor } from 'palette/Typography/constants';

export const TAG_THEMES = ['grey', 'primary', 'positive', 'attention', 'warning'] as const;
export type TagTheme = typeof TAG_THEMES[number];

export const TAG_FONT_COLORS_BY_THEME: Record<TagTheme, FontColor> = {
    grey: 'strong',
    positive: 'white',
    primary: 'white',
    warning: 'white',
    attention: 'attention',
};
